import { render, staticRenderFns } from "./MemberSettingsEditMetricEntriesForm.vue?vue&type=template&id=680096c6&scoped=true&lang=pug&"
import script from "./MemberSettingsEditMetricEntriesForm.vue?vue&type=script&lang=js&"
export * from "./MemberSettingsEditMetricEntriesForm.vue?vue&type=script&lang=js&"
import style0 from "./MemberSettingsEditMetricEntriesForm.vue?vue&type=style&index=0&id=680096c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680096c6",
  null
  
)

export default component.exports